import type { DateRangeType, PeriodGranularityType, PeriodReferentialIntervalType } from '../types/period.type';
import { computePresetRange, isPresetAvailable } from './periodPresets.utils';
import { parsePeriodValue } from './periodValue.utils';

/**
 * Single entry point turning a `period` field value into real dates. Presets need the
 * granularity and the refresh state to be resolved; an explicit range never does. Returns null instead of
 * throwing so callers (validation, mapping, UI) decide what an unresolvable value means for them.
 */
export function resolvePeriodRange(
  raw: unknown,
  granularity?: PeriodGranularityType,
  interval?: PeriodReferentialIntervalType | null
): DateRangeType | null {
  const value = parsePeriodValue(raw);

  if (!value) {
    return null;
  }

  if (value.kind === 'custom') {
    return value.range;
  }

  if (!granularity || !interval || !isPresetAvailable(value.option, granularity)) {
    return null;
  }

  return computePresetRange(value.option, granularity, interval);
}
